module.exports = __webpack_public_path__ + "assets/img/road.3bff71ce.png";